class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.initSelectors();
    this.jsonData = JSON.parse(this.jsonDataElement.textContent);
    this.unit = this.querySelector("unit-toggle").dataset.unit;
    document.addEventListener("unit-change", this.unitChangeHandler.bind(this));
    this.submitButton?.addEventListener(
      "click",
      this.refreshResults.bind(this)
    );
    this.mesServiceButton?.addEventListener(
      "click",
      this.openMeasurementService.bind(this)
    );
    this.convertTableSizes();
    console.log('size-guide');
    
    document.querySelector('[data-main-product] .size-guide-opener').classList.remove('visually-hidden');
  }

  initSelectors() {
    this.jsonDataElement = this.querySelector("[data-size-guide-json]");
    this.submitButton = this.querySelector("[data-btn-next-step]");
    this.sizeInputs = this.querySelectorAll(
      "measurement-input [data-size-input]"
    );
    this.lengthInputs = this.querySelectorAll("[data-length-input]");
    this.tableSizes = this.querySelectorAll("table [data-size]");
    this.tableHeights = this.querySelectorAll("table [data-height]");
    this.resultSize = this.querySelector("[data-result-size]");
    this.resultMessage = this.querySelector("[data-result-message]");
    this.resultLength = this.querySelector("[data-result-length]");
    this.resultMeasurements = this.querySelector("[data-result-measurements]");
    this.mesServiceButton = this.querySelector("[data-btn-mes-service]");
    this.resultTitle = this.querySelector("[data-result-title]");
    this.modal = this.closest("modal-dialog");
  }

  unitChangeHandler(e) {
    this.unit = e.detail.unit;
    this.convertTableSizes();
    this.convertTableHeights();
    this.refreshResults();
  }

  convertTableSizes() {
    this.tableSizes?.forEach((size) => {
      let cellContent = size.dataset.size;
      if (this.unit === "cm") {
        cellContent = measurementHelpers.convertValue(
          size.dataset.size,
          "in",
          "cm"
        );
      }

      size.textContent = measurementHelpers.round(cellContent, 2);
    });
  }

  openMeasurementService() {
    const customSizeOption = document.querySelector(
      "[data-main-product] [data-custom-size-option]"
    );
    if (customSizeOption) {
      customSizeOption.click();
      const mesServiceOpener = document.querySelector(
        "[data-main-product] [data-mes-service-opener]"
      );
      if (mesServiceOpener) {
        mesServiceOpener.click();
        this.modal?.hide();
      }
    }
  }

  convertTableHeights() {
    // Get the height data from lengthInputs in JSON
    const lengthMetaObject = this.jsonData.lengthInputs[0];
    if (!lengthMetaObject) {
      console.error("convertTableHeights: No height data found");
      return;
    }

    // Update each height element with the corresponding JSON data
    this.tableHeights?.forEach((th, index) => {
      // Find the corresponding height range from JSON
      const inputString = lengthMetaObject.lengths[index];
      if (inputString) {
        // Use the helper to parse the height range
        const lengthData =
          measurementHelpers.getLengthDataFromInput(inputString);

        // Format the height range for display in the current unit
        const displayText = measurementHelpers.formatHeightRangeForUnit(
          lengthData,
          this.unit
        );
        th.textContent = displayText;
      }
    });
  }

  getSizeData() {
    const sizeCodes = [];
    let outsideAcceptableRange = false;
    
    this.sizeInputs.forEach((input) => {
      const sizeName = input.dataset.sizeName;
      const userValue =
        this.unit === "in"
          ? parseFloat(input.value)
          : measurementHelpers.convertValue(input.value, "cm", "in");

      if (isNaN(userValue) || userValue <= 0) {
        console.error(`Invalid user value for ${sizeName}: ${userValue}`);
        return;
      }

      const measurementData = this.jsonData.sizeInputs.find(
        (item) => item.input_name === sizeName
      );

      if (!measurementData) {
        console.error(`No measurement data found for ${sizeName}`);
        return;
      }

      const sizeMap = {
        xxs_size: { code: "XXS", index: 0 },
        xs_size: { code: "XS", index: 1 },
        s_size: { code: "S", index: 2 },
        m_size: { code: "M", index: 3 },
        l_size: { code: "L", index: 4 },
        xl_size: { code: "XL", index: 5 },
        xxl_size: { code: "XXL", index: 6 },
      };

      // Find min and max size values for this measurement
      let minSize = Infinity;
      let maxSize = -Infinity;
      let closestSizeKey = null;
      let minDifference = Infinity;
      
      Object.entries(sizeMap).forEach(([sizeKey, sizeInfo]) => {
        if (sizeKey in measurementData && measurementData[sizeKey]) {
          const sizeValue = parseFloat(measurementData[sizeKey]);
          if (isNaN(sizeValue)) return;
          
          // Update min/max size values
          minSize = Math.min(minSize, sizeValue);
          maxSize = Math.max(maxSize, sizeValue);
          
          // Find the closest size
          const difference = Math.abs(userValue - sizeValue);
          if (difference <= minDifference) {
            minDifference = difference;
            closestSizeKey = sizeKey;
          }
        }
      });
      
      // Check if user value is outside acceptable range
      if (userValue >= maxSize + 4 || userValue <= minSize - 4) {
        outsideAcceptableRange = true;
      }

      if (closestSizeKey) {
        sizeCodes.push({
          sizeName: sizeName,
          sizeCode: sizeMap[closestSizeKey].code,
          index: sizeMap[closestSizeKey].index,
          userValue: userValue,
        });
      }
    });

    console.log(sizeCodes, {outsideAcceptableRange});
    return { sizeCodes, outsideAcceptableRange };
  }

  getSizeResult(sizeData) {
    if (!sizeData || !sizeData.sizeCodes || sizeData.sizeCodes.length === 0) {
      console.error("No size data available");
      return { outsideAcceptableRange: sizeData?.outsideAcceptableRange || false };
    }
    
    const sizeCodes = sizeData.sizeCodes;
    const outsideAcceptableRange = sizeData.outsideAcceptableRange;

    const biggestSizeIndex = Math.max(...sizeCodes.map((code) => code.index));

    const biggestSizeCode =
      sizeCodes.find((code) => code.index === biggestSizeIndex)?.sizeCode || "";

    const matchingCount = sizeCodes.filter(
      (code) => code.index === biggestSizeIndex
    ).length;
    const totalCount = sizeCodes.length;

    const differingCount = totalCount - matchingCount;

    const allSame = differingCount === 0;

    const hasLargeDifference = sizeCodes.find(
      (code) => biggestSizeIndex - parseInt(code.index) > 1
    );

    const mostMatch = differingCount > 0 && !hasLargeDifference;

    return { allSame, mostMatch, biggestSizeCode, outsideAcceptableRange };
  }

  getLengthResult() {
    if (!this.lengthInputs || this.lengthInputs.length === 0) {
      return null;
    }

    // Get the first length input value
    const lengthInput = this.lengthInputs[0];
    let userHeight =
      this.unit === "in"
        ? parseFloat(lengthInput.value)
        : measurementHelpers.convertValue(lengthInput.value, "cm", "in");

    if (isNaN(userHeight) || userHeight <= 0) {
      console.error(`Invalid height value: ${userHeight}`);
      return null;
    }

    const lengthMetaObject = this.jsonData.lengthInputs[0];

    if (!lengthMetaObject) {
      console.error(`getLengthResult: No height data found`);
      return null;
    }

    // Create an array to keep track of parsed height ranges
    const heightRanges = [];

    // Parse the height ranges from the JSON data
    lengthMetaObject.lengths.forEach((inputString) => {
      // Use the helper to parse the range
      const heightRange =
        measurementHelpers.getLengthDataFromInput(inputString);
      heightRanges.push(heightRange);
    });

    // Find the appropriate height range for the user's height
    for (const range of heightRanges) {
      if (userHeight >= range.minHeight && userHeight <= range.maxHeight) {
        // Return the length value, converting to cm if needed
        return this.unit === "in"
          ? range.length
          : measurementHelpers.convertValue(range.length, "in", "cm");
      }
    }

    // If no exact match, find the closest range
    let closestRange = null;
    let minDistance = Infinity;
    for (const range of heightRanges) {
      const distToMin = Math.abs(userHeight - range.minHeight);
      const distToMax = Math.abs(userHeight - range.maxHeight);
      const minDist = Math.min(distToMin, distToMax);
      if (minDist <= minDistance) {
        minDistance = minDist;
        closestRange = range;
      }
    }

    if (closestRange) {
      return this.unit === "in"
        ? closestRange.length
        : measurementHelpers.convertValue(closestRange.length, "in", "cm");
    }

    return null;
  }

  reset() {
    console.log("reset");
    this.resultSize && (this.resultSize.innerHTML = "");
    this.resultMessage?.classList.add("visually-hidden");
    this.mesServiceButton?.classList.add("visually-hidden");
    this.resultMeasurements?.classList.add("visually-hidden");
    this.resultLength && (this.resultLength.textContent = "");
    this.resultTitle && (this.resultTitle.textContent = "");
    this.resultMessage && (this.resultMessage.textContent = "");
  }

  showCustomSizeResult() {
    console.log("custom size");
    this.mesServiceButton?.classList.remove("visually-hidden");
    this.resultMeasurements?.classList.add("visually-hidden");
    this.resultMessage?.classList.remove("visually-hidden");
    this.resultMessage.textContent = this.resultMessage.dataset.noSizeMessage;
    this.resultTitle.textContent = this.resultTitle.dataset.noSizeTitle;
  }

  showAllSameResult() {
    console.log("all same");
    this.resultSize.textContent = this.biggestSizeCode;
    this.resultMeasurements?.classList.remove("visually-hidden");
    this.resultTitle.textContent = this.resultTitle.dataset.exactTitle;
   
  }

  showMostMatchResult() {
    console.log("most match");
    this.resultMeasurements?.classList.remove("visually-hidden");
    this.mesServiceButton?.classList.remove("visually-hidden");
    this.resultMessage?.classList.remove("visually-hidden");
    this.resultMessage.textContent = this.resultMessage.dataset.mostMatchMessage;
    this.resultTitle.textContent = this.resultTitle.dataset.mostMatchTitle;
    this.resultSize.textContent = this.biggestSizeCode;
  }

  refreshResults() {
    this.reset();
    this.sizeData = this.getSizeData();
    const { biggestSizeCode, allSame, mostMatch, outsideAcceptableRange } = this.getSizeResult(this.sizeData);
    this.biggestSizeCode = biggestSizeCode;
    const lengthResult = this.getLengthResult();

    if (this.resultSize) {
      // Outside acceptable range:
      if (outsideAcceptableRange) {
        this.showCustomSizeResult();
      // All same size:
      } else if (allSame) {
        this.showAllSameResult();
      // Most match size:
      } else if (mostMatch) {
        this.showMostMatchResult();
      // Default:
      } else {
        this.showCustomSizeResult();
      }
    }

    // Set length recommendation if available
    if (lengthResult !== null && this.resultLength) {
      let len = measurementHelpers.round(lengthResult, 2);
      this.resultLength.textContent =
        this.unit === "in" ? len + '"' : len + "cm";
    }
  }
}

if (!customElements.get("size-guide")) {
  customElements.define("size-guide", SizeGuide);
}
